{
  "responseShape": "서버 응답이 예상한 형식과 일치하지 않습니다 — 새로고침하세요.",
  "badRequest": "잘못된 요청입니다. 입력 내용을 확인하세요.",
  "forbidden": "이 작업을 수행할 권한이 없습니다.",
  "facilityRequired": "이 모듈을 사용하려면 헤더에서 시설을 선택하세요.",
  "notFound": "리소스를 찾을 수 없습니다.",
  "conflict": "리소스가 이미 존재합니다.",
  "validation": "검증 오류.",
  "tooManyRequests": "요청이 너무 많습니다. 잠시 후 다시 시도하세요.",
  "serverError": "서버 오류. 잠시 후 다시 시도하세요.",
  "unexpected": "예기치 않은 오류가 발생했습니다.",
  "network": "네트워크 오류. 연결을 확인하세요.",
  "requestSetup": "오류가 발생했습니다. 다시 시도하세요.",
  "sessionExpired": "세션이 만료되었습니다. 다시 로그인하세요."
}
